/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {CreateWrapper} from './containers/CreateClient'
import {ListWraaper} from './containers/List'

export function ClientPage() {
  useEffect(() => {}, [])

  return (
    <div>
      <Switch>
        <Route path='/client/list' exact={true} component={ListWraaper} />
        <Route path='/client/create' exact={true} component={CreateWrapper} />
        <Redirect from='/client' exact={true} to='/client/list' />
        <Redirect to='/client/list' />
      </Switch>
    </div>
  )
}
